import React, { Component } from 'react';
import ViewHeader from '../../components/ViewHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { Image as NativeImage } from 'react-native';
import { FaPencilAlt, FaRegWindowClose, FaArrowLeft, FaTrashAlt } from 'react-icons/fa';
import { connect } from 'react-redux';
import { storeSelectors, storeOperations } from './state';
import { bindActionCreators } from 'redux';
import FormTemplate from '../../components/FormTemplate';
import { Row, Col } from 'react-bootstrap';
import { IMAGE_SIZE, MODE_ADD, MODE_VIEW, MODE_EDIT, ERROR, SUCCESS, DATE_FORMAT, NOTIF_SUCCESS, NOTIF_ERROR, DEFAULT_STORE_ID, NOTIF_WARNING, EMPTY_STRING, SECONDARY,
    CANCEL, SUCCESS_BUTTON, SAVE, BACK, PRIMARY, UPDATE, DANGER, DELETE, STORE_DETAILS, NO, YES,STORE_ID, DELETE_STORE, IS_OBJECT} from '../../../utils/constants';
import { isNullOrUndefined } from 'util';
import { STORES_ROUTE, VIEW_STORE_ROUTE } from './routes';
import moment from 'moment';
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';
import ConfirmationModal from '../../components/ConfirmationModal';
import { SideNotification, recordImageStyle, isValidImageType } from '../../../utils/common';
import Advertisement from '../Advertisments/Advertisement';
import { MSG_DEFAULT_ERROR, MSG_CONFIRM_CHANGES, STORE_IMAGE_REQUIRED, IMAGE_SIZE_MESSAGE, RECOMMENDED_SIZE_700, CANNOT_DELETE_SHSAA, SAVE_CHANGES, DELETE_MESSAGE, MSG_INVALID_IMAGE_TYPE } from '../../../utils/messages';
import PendingAdvertisement from '../Advertisments/PendingAdvertisement';
import debounce from 'lodash.debounce';

class ViewStore extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imageFile: null,
            storeId: 0,
            mode: MODE_ADD,
            initialStoreDetails: null,
            imageHash: Date.now(),
            imageError: false,
            showSaveModal: false,
            showDeleteModal: false,
            storeDetails: [],
            adsSearch: '',
            imageErrorSize: false,
            hasSubmit: false
        }

        //Required to make submission possible on external button
        this.storeForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
        this.deleteStore = debounce(this.deleteStore.bind(this), 500);
    }

    componentDidMount() {
        let id = this.props.match.params.id;

        if (undefined === id) {
            this.setState({ mode: MODE_ADD })
        } else {
            let type = isNullOrUndefined(this.props.location.state) ? MODE_VIEW : this.props.location.state.type;

            this.setState({ storeId: id, mode: type }, () => {
                this.props.getStoreById(this.state.storeId)
                    .then((response) => {
                        if (ERROR === response.status) {
                            SideNotification(NOTIF_ERROR, response.message)
                        } else {
                            let store = response.data;
                            store.startDate = moment(store.storeStartDate).format(DATE_FORMAT);
                            store.endDate = moment(store.storeEndDate).format(DATE_FORMAT);
                            this.setState({ initialStoreDetails: { StoreModel: response.data } })
                        }
                    })
                    .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
            })
        }
    }

    isViewMode = () => {
        return MODE_VIEW === this.state.mode;
    }

    handleAdsSearchChange = (event) => {
        this.setState({ adsSearch: event.target.value });
    }

    uploadImageContainer = () => {
        return (
            <React.Fragment>
                <center><label><b className={this.isViewMode() ? EMPTY_STRING : "required-input"}>Store Image</b></label><br /></center>
                <Col className="flex-align">
                    <NativeImage
                        source={{ uri: (isNullOrUndefined(this.state.imageFile) ? `${REST_SERVICE_URL_ROOT}/store/image/${this.state.storeId}?${this.state.imageHash}` : URL.createObjectURL(this.state.imageFile)) }}
                        style={recordImageStyle}
                        resizeMode={(MODE_ADD === this.state.mode && isNullOrUndefined(this.state.imageFile)) ? "contain" : "cover"}
                    />
                </Col>
                <br />
                {MODE_VIEW !== this.state.mode && (
                    <div className="flex-align">
                        <div>
                            {this.state.imageError && <><label className="formik-error">{STORE_IMAGE_REQUIRED}</label><br /></>}
                            {this.state.imageErrorSize && <><label className="formik-error">{IMAGE_SIZE_MESSAGE}</label><br /></>}
                            <input type='file' id='photo' accept='image/*' onChange={this.handleImageFile} /><br /><br />
                            <b>{RECOMMENDED_SIZE_700}</b>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }

    toggleDelete = () => {
        if (DEFAULT_STORE_ID === Number(this.state.storeId)) {
            SideNotification(NOTIF_WARNING, CANNOT_DELETE_SHSAA);
        } else {
            this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal }))
        }
    }

    handleSubmit = (values) => {
        let newStore = values.StoreModel;
        newStore.storeStartDate = moment(newStore.startDate);
        newStore.storeEndDate = moment(newStore.endDate);

        if (isNullOrUndefined(this.state.imageFile) && MODE_ADD === this.state.mode) {
            this.setState({ imageError: true })
        } else {
            this.setState({ imageError: false, imageErrorSize: false, storeDetails: values }, () => this.toggleSave());
        }
    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    saveChanges = () => {
        
        let values = this.state.storeDetails;
        
        values.StoreModel.storeSponsorship = IS_OBJECT === typeof values.StoreModel.storeSponsorship ? values.StoreModel.storeSponsorship.floatValue : values.StoreModel.storeSponsorship
        if (MODE_EDIT === this.state.mode) {
            this.props.updateStore(values.StoreModel, this.state.imageFile)
                .then(result => {
                    if (SUCCESS === result.status) {
                        this.setState({ mode: MODE_VIEW, showSaveModal: false, initialStoreDetails: { StoreModel: values.StoreModel } })
                        SideNotification(NOTIF_SUCCESS, result.message);
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        } else {
            this.props.insertStore(values.StoreModel, this.state.imageFile)
                .then(result => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.props.history.push({ pathname: VIEW_STORE_ROUTE + `/${result.data}`, state: { type: MODE_VIEW } });
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }

    handleImageFile = (event) => {
        if (isNullOrUndefined(event.target.files[0]) || isValidImageType(event.target.files[0])) {
            if (!isNullOrUndefined(event.target.files[0]) && Number(IMAGE_SIZE) < event.target.files[0].size) {
                this.setState({ imageErrorSize: Number(IMAGE_SIZE) < Number(event.target.files[0].size), imageError: false, imageFile: null })
            }
            else {
                this.setState({ imageFile: event.target.files[0], imageErrorSize: false }, () => { MODE_ADD === this.state.mode && this.setState({ imageError: isNullOrUndefined(this.state.imageFile) }) })
            }
        } else {
            SideNotification(NOTIF_ERROR, MSG_INVALID_IMAGE_TYPE);
        }
    }

    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    onSubmitClick = () => {
        this.form.submitForm();
        this.setState({ hasSubmit: true })
        if (MODE_ADD === this.state.mode) {
            this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
        }
    }

    onCancelClick = () => {
        
        if(!isNullOrUndefined(this.state.initialStoreDetails)){
            this.form.resetForm(this.state.initialStoreDetails);
        }
        
        this.updateMode(MODE_VIEW);
    }

    updateMode = (mode) => {
        if (null !== this.state.initialStoreDetails) {
            this.setState({ mode });
        }
    }

    deleteStore = () => {
        this.props.deleteStore(this.state.storeId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.props.history.push(STORES_ROUTE);
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }


    renderRightButtons = () => {
        switch (this.state.mode) {
            case MODE_ADD: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: () => this.props.history.push(STORES_ROUTE) },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            case MODE_EDIT: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            default: {
                return [
                    { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(STORES_ROUTE) },
                    { variant: PRIMARY, label: UPDATE , icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                    { variant: DANGER, label: DELETE, icon: FaTrashAlt, onClick: this.toggleDelete }
                ]
            }
        }
    }

    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    title={STORE_DETAILS}
                    rightButtons={this.renderRightButtons()}
                />
                <Row style={{ paddingTop: '30px' }}>
                    <Col md={6} className="flex-align">
                        <div>{this.uploadImageContainer()}</div>
                    </Col>
                    <Col md={6} className="flex-align">
                        <FormTemplate
                            editMode={MODE_ADD !== this.state.mode}
                            readOnly={MODE_VIEW === this.state.mode}
                            initialValues={this.state.initialStoreDetails}
                            bindSubmitFormik={this.bindSubmitFormik}
                            formInputs={this.props.storeForm}
                            validate={storeSelectors.validateForm}
                            updateFormRef={this.updateFormRef}
                            handleSubmit={this.handleSubmit}
                            hasSubmit={this.state.hasSubmit}
                        />
                    </Col>
                </Row>
                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_STORE}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deleteStore, variant: DANGER }
                    ]}
                />

                {/*Store's advertisement list*/}
                <hr /><br />
                {(STORE_ID < this.state.storeId && null !== this.state.initialStoreDetails) && (
                    <React.Fragment>
                        <Advertisement
                            storeId={this.state.storeId}
                            storeMode={this.state.mode}
                            handleAdsSearchChange={this.handleAdsSearchChange}
                        />
                        <br /><br />
                        <PendingAdvertisement
                            storeId={this.state.storeId}
                            adsSearch={this.state.adsSearch}
                        />
                    </React.Fragment>
                )}

            </ModuleContainer>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        storeForm: state.stores.storeForm,
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getStoreById: storeOperations.getStoreById,
        insertStore: storeOperations.insertStore,
        updateStore: storeOperations.updateStore,
        deleteStore: storeOperations.deleteStore
    },
    dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(ViewStore);